import { CoreEnums } from '@/utils/domain/constants';
import BaseFilters from './BaseFilters';

export default {
  ...BaseFilters.RemoteFilter,
  user: true,
  name: 'userId',
  label: 'global.text.user',
  apiRoute: 'user/paged',
  /** Shared global.apiData key — multiple user filters reuse one fetch. */
  dataCacheKey: 'user/paged',
  labelInValue: false,
  params: {
    ...BaseFilters.RemoteFilter.params,
    select: 'id,fullName',
    filter: 'isActive eq true',
    orderBy: 'fullName asc',
  },
};
